import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "../Button";
import Input from "../Input";
import DropDown from "../DropDown";

const Container = styled.div`
  border: 1px solid #eee;
  padding: 10px;
`;

export default function TurnaroundPremiumForm({ onSubmit }) {
  const [turnaround, setTurnaround] = useState(null);
  const [premium, setPremium] = useState(null);
  const isValid = Number(turnaround) >= 0 && parseFloat(premium) >= 0;

  const addPremium = () => {
    if (!isValid) return;
    onSubmit({ turnaround, premium });
  };

  const turnarounds = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
  ].map((x) => ({
    label: x,
    value: x,
  }));

  return (
    <Container>
      <div className="row">
        <div className="col-md-4">
          <DropDown
            placeholder={"Select Day"}
            options={turnarounds}
            value={turnaround}
            onChange={(o) => setTurnaround(o.value)}
          />
        </div>
        <div className="col-md-4">
          <Input
            placeholder={"Add Premium %"}
            className="form-control"
            value={premium}
            onPressEnter={addPremium}
            onChange={(e) => setPremium(e.target.value)}
          />
        </div>
        <div className="col-md-4">
          <Button
            title="Add Turnaround Premium"
            onClick={addPremium}
            primary
            block
            disabled={!isValid}
          />
        </div>
      </div>
    </Container>
  );
}
